import {AsxEquityUtil} from "./AsxEquityUtil";
import {Exchange} from "app/instruments/exchange/Exchange";
import {AsxIndexUtil} from "./AsxIndexUtil";
import {AsxEtfUtil} from "./AsxEtfUtil";
import {AsxHybridsUtil} from "./AsxHybridsUtil";
import {AsxFixedInterestsUtil} from "./AsxFixedInterestsUtil";
import {AsxCompanyOptionsUtil} from "./AsxCompanyOptionsUtil";

export class AsxInstrumentUtil {

    private static readonly TmcPattern = /[A-Z0-9]{3}[0-9]{3}/;

    public static isEquity(code: string): boolean {
        return AsxEquityUtil.isEquity(code);
    }

    public static isOption(code: string) {
        return code.length === 6;
    }

    public static isTmc(code: string): boolean {
        return AsxInstrumentUtil.TmcPattern.test(code);
    }

    public static isIndex(code: string): boolean {
        return AsxIndexUtil.isIndex(code);
    }

    public static guessExchange(code: string): Exchange   {
        if (AsxHybridsUtil.isHybrid(code)) {
            return AsxHybridsUtil.exchange(code);
        } else if (AsxFixedInterestsUtil.isFixedInterest(code)) {
            return AsxFixedInterestsUtil.exchange(code);
        } else if (AsxEtfUtil.isEtf(code)) {
            return Exchange.AXW;
        } else if (AsxIndexUtil.isIndex(code)) {
            return Exchange.ASX;
        } else if (AsxCompanyOptionsUtil.isCompanyOption(code)) {
            return Exchange.ASX;
        } else if (AsxInstrumentUtil.isOption(code)) {
            return Exchange.AOM;
        }   else if (AsxInstrumentUtil.isEquity(code)) {
            return Exchange.ASX;
        } else {
            throw Error("Unknown Instrument Type " + code);
        }
    }
}
